import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  console.log = () => {};
  enableProdMode();
}

(() => {
    if (window.location.href.includes('earth')) {
        window.name = 'Console-earth'
    } else if (window.location.href.includes('agni')) {
        window.name = 'Console-agni';
    } else if (window.location.href.includes('mars')) {
      window.name = 'Console-mars';
    } else if (window.location.href.includes('neptune')) {
      window.name = 'Console-neptune';
    } else if (window.location.href.includes('venus')) {
        window.name = 'Console-venus';
    } else if (window.location.href.includes('pluto')) {
        window.name = 'Console-pluto';
    } else if (window.location.href.includes('alpha')) {
        window.name = 'Console-alpha';
    } else if (window.location.href.includes('beta')) {
        window.name = 'preprod';
    } else if (window.location.href.includes('gamma')) {
      window.name = 'Console-gamma';
    } else if (window.location.href.includes('vahanacloud.net')) {
        window.name = 'preprod';
    } else if (window.location.href.includes('cug')) {
        window.name = 'Console-cug';
    } else if (window.location.href.includes('delta')) {
        window.name = 'Console-delta';
    }
    else {
        window.name = 'Console';
    }
})();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
